import { Reinsurer, ProgramFactor } from '../../core/model/reinsurer.model'

export const convertStudyReinsurersToFactors = (reinsurers: Reinsurer[]): ProgramFactor[] => {
  const seen = new Set<string>()
  return reinsurers
    .map((r) => r.reinsurerProgramFactor)
    .flat()
    .filter((f) => {
      const key = `${f.reinsurer_id}_${f.relation_seq_number}`
      return seen.has(key) ? false : (seen.add(key), true)
    })
}
